<template>
  <div class="animated fadeIn">
    <div class="d-flex flex-wrap align-items-center">
      <div class="mr-auto mb7">
        <label class="col-form-label font_20">
          WSFinder
        </label>
      </div>
    </div>
    <b-row v-if="!is_main">
      <b-col sm="6">
        <select v-model="limit" @change="$refs._list.refresh()">
          <option disabled value="20">Please select display count : Default 20</option>
          <option value="10">10</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
      </b-col>
      <b-col sm="6">
        <b-input-group size="sm">
          <b-input-group-prepend>
            <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
            <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
            <b-dropdown :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
              <b-dropdown-item size="sm" @click="so.sk='agent.name';so.skt='name'">name</b-dropdown-item>
              <b-dropdown-item size="sm" @click="so.sk='agent.host';so.skt='host'">host</b-dropdown-item>
            </b-dropdown>
          </b-input-group-prepend>
          <b-form-input v-model="so.sv" @keyup.enter="refresh()"></b-form-input>
          <b-input-group-append>
            <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
            <!-- <b-btn variant="outline-secondary"><i class="fa fa-search-plus"></i></b-btn> -->
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
    <div class="reg_card">
      <div class="reg_card_body">
        <div class="table-responsive">
          <b-table class="table table_add table-striped" hover striped responsive="sm" ref="_list" show-empty empty-text="관련된 정보가 없어요." :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage">
            <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
            <template slot="created_at" slot-scope="row">{{row.item.created_at | datetime}}</template>
            <template slot="action" slot-scope="row">{{row.item.action ? (codes.agent_forgery[row.item.action] || row.item.action) : '-' }}</template>
            <template slot="target" slot-scope="row">
              <span v-if="row.item.type.toUpperCase() == 'WMDS'">{{row.item.target ? row.item.target : '-'}}</span>
              <span v-else-if="row.item.target_type">
                [{{row.item.target_type}}]
                <span v-if="row.item.action.toUpperCase() == 'RENAME' && row.item.old_path">
                  {{row.item.old_path}} {{ row.item.old_hash ? `[${row.item.old_hash}]` : '' }}  ->
                </span>
                <span v-if="row.item.action.toUpperCase() == 'MOVE' && row.item.old_path">
                  {{row.item.old_path}} {{ row.item.old_hash ? `[${row.item.old_hash}]` : '' }}  ->
                </span>
                <span v-else>
                  {{ row.item.action.toUpperCase() == 'MODIFIED HASH' && row.item.old_path ? `${row.item.old_path} [${row.item.old_hash}] ->` : '' }}
                </span>
                {{row.item.path}} {{row.item.hash ? `[${row.item.hash}]` : ''}}
              </span>
              <span v-else>
                {{row.item.target ? row.item.target : row.item.path }}
              </span>
            </template>
            <!-- <template slot="now_snapshot" slot-scope="row">{{JSON.parse(row.item.now_snapshot).watching}}</template> -->
          </b-table>
        </div>
      </div>
    </div>
    <b-row class="mt30">
      <b-col class="pagination justify-content-center">
        <b-pagination size="sm" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" :limit="10" prev-text="<" next-text=">" />
      </b-col>
    </b-row>
    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>